import Config from "react-global-configuration"
import { useAuth } from "../services"

function useGlobalDashboard() {
  const { hasFeature } = useAuth()
  const { clientKiosk: kiosk, clientDevice: device } = Config.get()

  const showGlobalDashboardDemo = hasFeature("global_dashboard_demo") && !kiosk && !device
  const showGlobalDashboard = hasFeature("global_dashboard") && !kiosk && !device

  return {
    showGlobalDashboardDemo,
    showGlobalDashboard
  }
}

export { useGlobalDashboard }
